import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { LocalStorage } from '../services/local-storage';
@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private localstorage : LocalStorage) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.localstorage.getStorage('token')) {
            // logged in so return true
    
            return true;
        }
      
      console.log("stateurl"+state.url);
        // not logged in so redirect to login page with the return url
        
        if(state.url.indexOf("admin") > -1){
     this.router.navigate(['admin/login'], { queryParams: { returnUrl: state.url }});
        }
        else if(state.url.indexOf("advertiser") > -1){
     this.router.navigate(['advertiser/adlogin'], { queryParams: { returnUrl: state.url }});
        }
        else{
        this.router.navigate(['users/login'], { queryParams: { returnUrl: state.url }});
        
    }
    return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/guards/auth.guard.component.ts